import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { ReportJobStatusEnum } from '../enums/report-job-status.enum';

/**
 * Report jobs filters
 */
export class ReportJobsFilters extends ApiRequestFilters {
	/**
	 * Status values
	 */
	statuses?: ReportJobStatusEnum[];
}
